export enum WorkflowActionType {
    ReviewResponse = "reviewResponse",
    ReviewResponseNpc = "recordReviewerResponse",
    Log = "log",
    Forward = "forward",
    RespondClose = "respondClose",
}
